<template>
  <div class="seo-block">
    <wrap>
      <div class="seo-block__inner">
        <div v-html="text" />
        <slot />
      </div>
    </wrap>
  </div>
</template>

<script setup lang="ts">
  import Wrap from '@/shared/ContentWrap.vue';

  defineProps<{
    text: string;
  }>();
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as legacy-typography;
  @use '@experience/shared/dist/assets/adaptivity' as legacy-adaptivity;

  .seo-block {
    color: var(--alias-color-text-default);
    border-top: 1px solid var(--alias-color-border-default);

    :deep(h2) {
      max-width: 960px;
      margin: 0 0 16px;
      color: var(--alias-color-text-default);

      @include legacy-typography.base-700-700-semi;
    }

    :deep(h3) {
      font-weight: 600;
    }

    :deep(p) {
      max-width: 960px;
      margin: 12px 0;

      & + h2 {
        margin-top: 40px;
      }
    }

    :deep(.azure-link) {
      color: var(--alias-color-link-default);

      &:hover {
        color: var(--alias-color-link-default-hovered);
      }
    }

    :deep(ul) {
      padding: 0 24px;
      margin: 12px 0;
      list-style: disc;

      li {
        margin: 4px 0 0;

        &:first-child {
          margin-top: 0;
        }
      }
    }

    @include legacy-adaptivity.tablet {
      padding: 48px 0 0;
    }

    @include legacy-adaptivity.mobile {
      padding: 40px 0 0;
    }

    @include legacy-typography.base-400-400-regular;

    @media only screen and (width <= 767px) {
      :deep(h2) {
        margin: 0 0 12px;

        @include legacy-typography.base-600-500-semi;
      }

      :deep(p + h2) {
        margin-top: 32px;
      }
    }
  }

  .seo-block__inner {
    display: grid;
    gap: 32px;
  }

  :deep(.schedule-content) {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .row {
      display: flex;
      gap: 16px;
    }

    .exp-date {
      min-width: 170px;
    }

    @include legacy-adaptivity.tablet {
      gap: 16px;

      .row {
        flex-direction: column-reverse;
        gap: 0;
      }
    }
  }
</style>
